import React, { useRef } from "react";

/**
 * Props:
 *  - checked (boolean)
 *  - onChange (function) -> receives the native event (same shape as <input onChange>)
 *  - onColor (string) -> track color when ON (hex or rgb)
 *  - offColor (string) -> track color when OFF
 *  - size: 'sm' | 'md' | 'lg' (optional)
 */
export default function CustomToggle({
  checked = false,
  onChange = () => {},
  onColor = "#2978B5",
  offColor = "#d9e2ec",
  size = "md",
  id,
  ariaLabel = "toggle",
}) {
  const idRef = useRef(id || `kc-toggle-${Math.random().toString(36).slice(2, 9)}`);

  const sizes = {
    sm: { width: 40, height: 22, knob: 18, padding: 2 },
    md: { width: 35, height: 20, knob: 16, padding: 2 },
    lg: { width: 60, height: 34, knob: 30, padding: 2 },
  };
  const s = sizes[size] || sizes.md;

  const styleVars = {
    // css custom props used by the internal CSS
    "--kc-on": onColor, 
    "--kc-off": offColor,
    "--kc-width": `${s.width}px`,
    "--kc-height": `${s.height}px`,
    "--kc-knob": `${s.knob}px`,
    "--kc-padding": `${s.padding}px`,
  };

  return (
    <>
      <div className="kc-custom-toggle" style={styleVars}>
        <input
          id={idRef.current}
          className="kc-toggle-input"
          type="checkbox"
          checked={checked}
          onChange={onChange}
          aria-label={ariaLabel}
        />
        <label className="kc-toggle-label" htmlFor={idRef.current}>
          <span className="kc-track">
            <span className="kc-thumb" />
          </span>
        </label>
      </div>

    </>
  );
}
